/**
 * Afterpay Integration
 * Optimized for async loading with Liquid data
 * Generated via Liquid template
 */

(function() {
  'use strict';

  // Early exit if already loaded
  if (window.afterpayIntegrationLoaded) return;
  window.afterpayIntegrationLoaded = true;

  try {
    // Afterpay Liquid variables
    window.afterpay_product = null;
    window.afterpay_product_variant = null;
    window.afterpay_cart_total_price = null;
    
    // Initialize Afterpay when available
    function initializeAfterPay() {
      if (typeof afterpay !== 'undefined' && afterpay.init) {
        afterpay.init();
        console.log('✅ Afterpay initialized successfully');
      }
    }
    
    // Check if Afterpay is already loaded or wait for it
    if (typeof afterpay !== 'undefined') {
      initializeAfterPay();
    } else {
      // Poll for Afterpay availability
      var checkCount = 0;
      var checkInterval = setInterval(function() {
        checkCount++;
        if (typeof afterpay !== 'undefined') {
          clearInterval(checkInterval);
          initializeAfterPay();
        } else if (checkCount > 20) { // Stop after 10 seconds
          clearInterval(checkInterval);
          console.warn('⚠️ Afterpay not found after 10 seconds');
        }
      }, 500);
    }
    
  } catch (error) {
    console.warn('Afterpay integration failed:', error);
  }

})();